import React, { useEffect } from 'react';
import { FormGroup, HelpBlock } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import ReactPhoneInput from 'react-phone-input-2';

export const NumberField = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched, setFieldError, setFieldValue },
  label,
  type,
  labelCol = 'col-lg-4 col-form-label',
  inputCol = 'col-lg-8',
  step,
  placeholder,
  max,
  min,
  defaultCountry = 'es',
  ...props
}) => {
  const inputId = `${name}-number-input`; // Generate a unique ID for the input field

  const phoneNumber = (number) => {
    var phoneno =
      /(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})/;
    if (!number.match(phoneno)) {
      return false;
    }
    return true;
  };

  
  useEffect(() => {
    const inputElement = document.getElementById(inputId);
    const flagElement = document.getElementsByClassName('flag 0');

    if (inputElement && !inputElement.value) {
      flagElement[0].className = 'flag es';
    }

  }, []);

  return (
    <div className="row">
      <div className={labelCol}>
        <p className="profile-label">{label}</p>
      </div>
      <div className={inputCol}>
        <FormGroup
          controlId={name}
          validationState={touched[name] && errors[name] ? 'error' : null}
        >
          <ReactPhoneInput
            inputProps={{
              id: inputId, // Assign the ID to the input field
              name: name,
              required: false,
              autoFocus: false
            }}
            inputClass="profile-input"
            country={defaultCountry}
            value={value}
            placeholder={placeholder || 'Enter phone number'}
            onBlur={(e) => {
              const inputElement = document.getElementById(inputId);
              if (inputElement) {
                onBlur(e);
              }
            }}
            onChange={(val) => {

              if (!phoneNumber(val)) {
                setFieldError(name, <FormattedMessage id="activation-form.contactError" />);
              }
              setFieldValue(name, val);
            }}
            {...props}
          />

          <HelpBlock>{touched[name] && errors[name]}</HelpBlock>
        </FormGroup>
      </div>
    </div>
  );
};
